// extracted by mini-css-extract-plugin
export default {"successIcon":"Common_successIcon__esLe6","warningIcon":"Common_warningIcon__sIPxO","errorIcon":"Common_errorIcon__2uDwF"};